import { hierarchy } from './config/config.default.ts';

export { hierarchy, roles } from './config/config.default.ts';
export { appConfig, withConfiguredDevPorts } from './src/config-builder/app-config.ts';
export { type ConfigSwitch, isStrategyEnabled, isSwitchOn } from './src/config-builder/config-switch.ts';
export type { ConfigMode } from './src/config-builder/types.ts';

// The app singleton's own arrow fields, so binding survives destructuring. Test mocks replacing
// `hierarchy` must override these from the same synthetic instance.
export const { isChannel, isProduct } = hierarchy;

export type { EntityHierarchy } from './src/config-builder/entity-hierarchy.ts';
export {
  createEntityHierarchy,
  createRoleRegistry,
} from './src/config-builder/entity-hierarchy.ts';
// Home attribution and paths are instance methods on EntityHierarchy; only the naming rule and
// the pure path-string helpers are free exports.
export type { ResolvedAncestor } from './src/config-builder/resolve-row-channel.ts';
export { entityIdColumnKey, entityIdColumnName } from './src/config-builder/resolve-row-channel.ts';
export { pathHomeId, pathSegments, pathStartsWith } from './src/config-builder/row-path.ts';
export type { FederationConfig, RequiredConfig, S3Config, S3ConfigInput } from './src/config-builder/types.ts';
export { nonEmpty, recordFromKeys, typedEntries } from './src/config-builder/utils.ts';
export type {
  AccessMembership,
  ActionAttribution,
  AncestorChannelIds,
  CanHome,
  CanState,
  ChannelIdColumns,
  ChannelPolicyBuilder,
  ConditionActor,
  EntityActionPermissions,
  EntityCanMap,
  EntityPolicies,
  GrantSource,
  HierarchyOverrides,
  PermissionCheckOptions,
  PermissionDecision,
  PermissionsConfigResult,
  PolicyCallback,
  PolicyCell,
  PolicyCellInput,
  PolicyConfiguration,
  PolicyEntry,
  PolicyMatrix,
  PublicReadGrants,
  ResolvedChannelIds,
  RowConditionName,
  RowForCondition,
  SubjectForPermission,
} from './src/permissions/index.ts';
export {
  type Access,
  type AccessScope,
  type AccessScopedEntityType,
  accessScopes,
  allActionsAllowed,
  allActionsDenied,
  type BatchPermissionResult,
  buildSubject,
  buildSubjectFromEntity,
  checkAccess,
  checkAccessBatch,
  checkAccessFanout,
  computeCan,
  configurePermissions,
  createActionRecord,
  getAllDecisions,
  getEntityPolicies,
  getPolicyPermissions,
  isRowCondition,
  isUnconditionalCan,
  MissingAncestorError,
  matchesRowCondition,
  type PermissionResult,
  type PredicateActor,
  policyMatrix,
  publicReadGrants,
  resolveCan,
  toColumnName,
  toTableName,
  validateAncestorScope,
  validateMembership,
  validateSubject,
} from './src/permissions/index.ts';
export { draftVisibleTo, isUnpublishedDraft } from './src/published-rows.ts';
export { seenWindowMs } from './src/seen-window.ts';
export type {
  ActivityAction,
  ActivityVerb,
  AncestorChannelType,
  ChannelEntityType,
  EnabledOAuthProvider,
  EntityActionType,
  EntityIdColumnKey,
  EntityIdColumns,
  EntityRole,
  EntityType,
  FederationKey,
  Language,
  MenuSection,
  NullableAncestorType,
  OrganizationFlags,
  OrganizationRole,
  OrganizationSetupConfig,
  ProductEntityType,
  PropagationHint,
  RelatedChannelType,
  ResourceType,
  SeenTrackedProductType,
  Severity,
  SystemRole,
  Theme,
  TokenType,
  TrackedEventType,
  UploadTemplateId,
  UserFlags,
} from './types.ts';
export { actionToVerb, activityActions, isValidEventType, trackedEventTypes } from './types.ts';

// Side-effect import: compile-time check that the config matches the hierarchy.
import './src/config-builder/config-validation.ts';
